import React, { createContext, useContext, useState } from 'react'
import { NavContextProps } from './ContentfulNavigation.d'

export const navContextDefaults: NavContextProps = {
  desktopNavHeight: 0,
  heapClasses: null,
  isKeyboardNavigation: false,
  isMobileNavOpen: false,
  isOverlayOpen: false,
  isRegionMenuOpen: false,
  localizedEntries: [],
  mobileShowcase: null,
  navigationData: null,
  salesPhoneNumber: null,
  selectedParentMenu: null,
  selectedTabbedMenu: null,
  setDesktopNavHeight: () => {},
  setIsKeyboardNavigation: () => {},
  setIsMobileNavOpen: () => {},
  setIsOverlayOpen: () => {},
  setIsRegionMenuOpen: () => {},
  setSelectedParentMenu: () => {},
  setSelectedTabbedMenu: () => {},
  showLogin: false,
  showRegionSelector: false,
  showRequestDemo: false,
  showRestaurantSearch: false,
  showSalesInDesktopNav: false,
  showSalesInMobileMenu: false,
  showSalesInMobileNav: false,
  siteId: 1,
  siteRegion: null,
  useUtilityNav: false
}

export const NavContext = createContext<NavContextProps>({
  ...navContextDefaults
})

export const NavContextProvider = ({
  children,
  value
}: {
  children: any
  value?: any
}) => {
  const [desktopNavHeight, setDesktopNavHeight] = useState<number>(
    value?.desktopNavHeight || 0
  )
  const [isMobileNavOpen, setIsMobileNavOpen] = useState<boolean>(
    value?.isMobileNavOpen || false
  )
  const [isKeyboardNavigation, setIsKeyboardNavigation] = useState<boolean>(
    value?.isMobileNavOpen || false
  )
  const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(
    value?.isOverlayOpen || false
  )
  const [isRegionMenuOpen, setIsRegionMenuOpen] = useState<boolean>(
    value?.isRegionMenuOpen || false
  )
  const [selectedParentMenu, setSelectedParentMenu] = useState<string | null>(
    value?.selectedParentMenu || null
  )
  const [selectedTabbedMenu, setSelectedTabbedMenu] = useState<string | null>(
    value?.selectedTabbedMenu || null
  )

  return (
    <NavContext.Provider
      value={{
        ...value,
        desktopNavHeight,
        isKeyboardNavigation,
        isMobileNavOpen,
        isOverlayOpen,
        isRegionMenuOpen,
        selectedParentMenu,
        selectedTabbedMenu,
        // Allow mock functions for jest testing
        setDesktopNavHeight: value?.setDesktopNavHeight || setDesktopNavHeight,
        setIsKeyboardNavigation:
          value?.setIsKeyboardNavigation || setIsKeyboardNavigation,
        setIsMobileNavOpen: value?.setIsMobileNavOpen || setIsMobileNavOpen,
        setIsOverlayOpen: value?.setIsOverlayOpen || setIsOverlayOpen,
        setIsRegionMenuOpen: value?.setIsRegionMenuOpen || setIsRegionMenuOpen,
        setSelectedParentMenu:
          value?.setSelectedParentMenu || setSelectedParentMenu,
        setSelectedTabbedMenu:
          value?.setSelectedTabbedMenu || setSelectedTabbedMenu
      }}
    >
      {children}
    </NavContext.Provider>
  )
}

export const useNavContext = () => {
  const context = useContext(NavContext)
  // Throw error if context is undefined, but allow this to run if in a Jest test environment
  // Todo - remove this Jest check and add context to the offending tests
  if (!context) {
    if (
      typeof process !== 'undefined' &&
      process.env.JEST_WORKER_ID !== undefined
    ) {
      return {
        ...navContextDefaults
      }
    } else {
      throw new Error('useNavContext must be used within a NavContext')
    }
  }
  return context
}
